export default "__VITE_ASSET__DGgx808J__"